import { render } from "./publikasi.vue?vue&type=template&id=f77489d4&scoped=true"
import script from "./publikasi.vue?vue&type=script&lang=js"
export * from "./publikasi.vue?vue&type=script&lang=js"

import "./publikasi.vue?vue&type=style&index=0&id=f77489d4&lang=scss&scoped=true"

import exportComponent from "C:\\Programming\\Padmaweb\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f77489d4"]])

export default __exports__